'use client'

import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { logout } from '../_actions/logout'
import { LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function LogoutButton() {
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const router = useRouter()

  async function handleLogout() {
    setIsPending(true)
    setError(null)

    const result = await logout()

    setIsPending(false)

    if (result.success) {
      // Redirect to home page after successful logout
      router.push('/')
    } else {
      // Display error message
      setError(result.error || 'Logout failed')
    }
  }

  return (
    <>
      {error && <p className="text-red-500">{error}</p>}
      <Button
        variant="ghost"
        size="sm"
        onClick={handleLogout}
        disabled={isPending}
        className="flex gap-2 items-center font-medium text-sm transition hover:opacity-80"
        title="Logout"
      >
        Logout
        <LogOut size={18} strokeWidth={1.5} />
      </Button>
    </>
  )
}
